module.exports = __webpack_public_path__ + "e433a1660e0d83a4ff4ac168b916d00b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-320.webp.png
// module id = 412
// module chunks = 0